import React from 'react'
import { Container, Row, Col } from 'reactstrap'

function Error403 () {
  return (
    <Container className='pt-5'>
      <Row>
        <Col>
          <img src='/static/img/logo.png' className='mb-4' />
          <h1 className='text-danger py-3'>
            We're sorry, but something went wrong
          </h1>
          <p>
            <b>
              You do not have access to <a href='https://myscphealth.com'>myscphealth.com</a>.
            </b>
          </p>
          <p>
            If you believe this is an error, please contact support at <a href='tel:8883541411' target='_new'>888-354-1411</a>.
          </p>
        </Col>
      </Row>
    </Container>
  )
}

function Error404 () {
  return (
    <div>
      <h1 className='text-danger py-3'>
        Oops, this page does not exist
      </h1>
      <p>
        We're sorry, we can't locate the page you've requested.
      </p>
      <p>
        The page may no longer exist or the URL requested may have errors.
      </p>
      <p>
        If you believe this is an error, please contact support at <a href='tel:8883541411' target='_new'>888-354-1411</a> or submit a support ticket.
      </p>
    </div>
  )
}

function GeneralError ({ statusCode, message }) {
  return (
    <Container className='pt-5'>
      <Row>
        <Col>
          <img src='/static/img/logo.png' className='mb-4' />
          <h1 className='text-danger py-3'>
            We're sorry, but something went wrong: {statusCode}
          </h1>
          <p>
            Message: {message}
          </p>
          <p>
            Please refresh the page and try again.
          </p>
          <p>
            If the problem persists, please contact support at <a href='tel:8883541411' target='_new'>888-354-1411</a> or submit a support ticket.
          </p>
        </Col>
      </Row>
    </Container>
  )
}

function CustomError ({ statusCode, message }) {
  let ErrorComponent = null

  if (statusCode === 403) {
    ErrorComponent = Error403
  } else if (statusCode === 404) {
    ErrorComponent = Error404
  } else {
    ErrorComponent = GeneralError
  }

  return (
    <ErrorComponent statusCode={statusCode} message={message} />
  )
}

CustomError.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : null

  return {
    title: `${statusCode}`,
    statusCode,
    message: err && err.message
  }
}

export default CustomError
